module.exports = __webpack_public_path__ + "static/media/creaturequiz.a944794d.jpeg";